import React, { useEffect, useState } from "react";
import { Button, Card, Col, Container, Row } from "react-bootstrap";
import { useInView } from "react-intersection-observer";
import { useAnimation, motion } from "framer-motion";

import Title from "../TitleDerecha";
import { desarrolloData } from "../../constants/servicioData";
import { IDesarrollo } from "../../models/interfaces/IServicio";
import ServicioModal from "../modals/ServicioModal";

import "../../styles/components/Servicio.scss";

const boxVariant = {
  visible: { opacity: 1, y: 0, transition: { duration: 1 } },
  hidden: { opacity: 0, y: 200 },
};

export default function Desarrollo() {
  const control = useAnimation();
  const [ref, inView] = useInView();
  const [estadoModal, setEstadoModal] = useState<boolean>(false);
  const [currentInfo, setCurrentInfo] = useState<IDesarrollo>({
    titulo: "",
    texto: "",
    img: ``,
    idDesarrollo: 0,
  });

  useEffect(() => {
    if (inView) {
      control.start("visible");
    }
  }, [control, inView]);

  return (
    <section id="servicios" >
      <motion.div
        className="box Servicios"
        ref={ref}
        variants={boxVariant}
        initial="hidden"
        animate={control}
      >
        <Title titulo="Servicios" scroll={inView}></Title>
        <Container className="mt-5">
          <Row>
            {desarrolloData.map((data) => (
              <Col xl={4} lg={4} md={6} sm={6} xs={12} className="p-1">            
                <Card>
                  <Card.Header>{data.icon}</Card.Header>
                  <Card.Body>
                    <Card.Title>{data.titulo}</Card.Title>
                    <Button
                      className="servicio_button"
                      onClick={() => {
                        setCurrentInfo(data);
                        setEstadoModal(true);
                      }}
                    >
                      Conocer mas
                    </Button>
                  </Card.Body>
                </Card>  
              </Col>
            ))}          
          </Row>

          <ServicioModal
            estadoModal={estadoModal}
            cambiarEstadoModal={setEstadoModal}
            infoServicio={currentInfo}
          />      
        </Container>
      </motion.div>
    </section>
    
  );
}